import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_side_menu = _resolveComponent("side-menu")!
  const _component_head_menu = _resolveComponent("head-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, { id: "mainContent" }, {
    default: _withCtx(() => [
      _createVNode(_component_side_menu),
      _createVNode(_component_head_menu),
      _createVNode(_component_ion_router_outlet, { id: "router" })
    ]),
    _: 1
  }))
}